import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import IconClose from '../../assets/icons/IconClose'
import ModalForm from '../../components/common/modal-form'
import ButtonRound from '../../components/elements/button-round'
import WrapIcon from '../../components/elements/WrapIcon'
import Textarea from '../../components/form/Textarea'
import { getCurrentGroupOrder } from '../../selectors'

const ModalUpdateNote = ({ food, handleCloseUpdateNote, handleSubmitNote }) => {
    const [note, setNote] = useState('')
    const inputRef = useRef()
    const isOpen = !!food
    const { t } = useTranslation()
    const groupOrder = useSelector(getCurrentGroupOrder)

    const handleSubmit = () => {
        handleSubmitNote(note)
    }

    useEffect(() => {
        setTimeout(() =>
            setNote(
                food?.groupOrder === groupOrder && food?.note ? food?.note : ''
            )
        )
    }, [isOpen])

    return (
        <ModalForm
            isOpen={!!food}
            centered
            containerClass="update-note-container"
            contentClass="update-note"
            rootClass="update-note-root"
        >
            <div className="update-note__head">
                <div className="name heading-6">
                    {t('modalNoteMobile.title')}
                </div>
                <div className="close" onClick={handleCloseUpdateNote}>
                    <WrapIcon size="20px" icon={IconClose} color="000000" />
                </div>
            </div>

            <div className="mt-4">
                <Textarea
                    value={note}
                    onChange={e => setNote(e.target.value)}
                    ref={inputRef}
                    rows={4}
                    autoFocus
                />
            </div>

            <div className="text-right mt-4">
                <ButtonRound className="btn-save" onClick={handleSubmit}>
                    {t('modalNoteMobile.btnSave')}
                </ButtonRound>
            </div>
        </ModalForm>
    )
}

export default ModalUpdateNote
